import React from 'react';

import { CallDetailPageContent } from './CallDetailPageContent';

const CallDetailPage = () => {
  return <CallDetailPageContent />;
};

export default CallDetailPage;
